import React, { useState } from "react";
import "./Profile.css";
import api from "../utils/api";
import { forceLogout } from "../contexts/AuthContext";

export default function Profile() {
  const storedUser = JSON.parse(localStorage.getItem("adm_panel_user") || "{}");

  const [email] = useState(storedUser.email || "");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [darkMode, setDarkMode] = useState(storedUser.darkmode || false);
  const [chartDefault, setChartDefault] = useState(
    storedUser.chartdefault || "minute"
  );

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [settingsError, setSettingsError] = useState("");
  const [settingsSuccess, setSettingsSuccess] = useState("");

  const validatePassword = (pwd) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,;:{}[\]()\-_=+^])[A-Za-z\d@$!%*?&.,;:{}[\]()\-_=+^]{8,}$/;
    return regex.test(pwd);
  };

  // ✅ PASSWORD CHANGE
  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!password || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
      );
      return;
    }

    try {
      await api.post("/change-password", {
        Password: password,
      });

      // ✅ eski davranış birebir
      setSuccess("Password updated successfully!");

      setTimeout(() => {
        forceLogout(); // daha temiz versiyon
      }, 1200);

    } catch (err) {
      console.error(err);

      // axios hata yakalama (res.ok yerine)
      if (err.response) {
        setError("Password update failed.");
      } else {
        setError("Server error.");
      }
    }
  };

  // ✅ SETTINGS SAVE
  const handleSettingsSave = async () => {
    setSettingsError("");
    setSettingsSuccess("");

    try {
      await api.post("/save-settings", {
        darkmode: darkMode,
        chartdefault: chartDefault,
      });

      setSettingsSuccess("Settings updated successfully!");

      // ✅ local update (aynı)
      const updatedUser = {
        ...storedUser,
        darkmode: darkMode,
        chartdefault: chartDefault,
      };

      localStorage.setItem("adm_panel_user", JSON.stringify(updatedUser));

      // ✅ dark mode apply (aynı)
      if (darkMode) {
        document.body.classList.add("dark-mode");
      } else {
        document.body.classList.remove("dark-mode");
      }

      setTimeout(() => setSettingsSuccess(""), 3000);

    } catch (err) {
      console.error(err);

      if (err.response) {
        setSettingsError("Settings update failed.");
      } else {
        setSettingsError("Server error.");
      }
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-card">
        <h2>Profile Settings</h2>

        <div className="profile-info">
          <label>Email</label>
          <input type="text" value={email} disabled />
        </div>

        <div className="settings-section">
          <h3>Preferences</h3>

          <div className="setting-item">
            <label>Dark Mode</label>
            <div className="toggle-switch">
              <input
                type="checkbox"
                id="darkmode-toggle"
                checked={darkMode}
                onChange={(e) => setDarkMode(e.target.checked)}
              />
              <label htmlFor="darkmode-toggle" className="toggle-slider"></label>
            </div>
          </div>

          <div className="setting-item">
            <label>Default Chart View</label>
            <select
              value={chartDefault}
              onChange={(e) => setChartDefault(e.target.value)}
              className="chart-default-select"
            >
              <option value="minute">Minute</option>
              <option value="hour">Hour</option>
              <option value="day">Day</option>
              <option value="week">Week</option>
              <option value="month">Month</option>
            </select>
          </div>

          <button onClick={handleSettingsSave} className="save-btn">
            Save Preferences
          </button>

          {settingsError && <p className="profile-error">{settingsError}</p>}
          {settingsSuccess && <p className="profile-message">{settingsSuccess}</p>}
        </div>

        <form onSubmit={handlePasswordChange} className="password-form">
          <h3>Change Password</h3>

          <label>New Password</label>
          <input
            type="password"
            placeholder="Enter new password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <p className="password-hint">
            Minimum 8 characters, including uppercase, lowercase, number, and special character.
          </p>

          <label>Confirm New Password</label>
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          <button type="submit" className="save-btn">
            Update Password
          </button>
        </form>

        {error && <p className="profile-error">{error}</p>}
        {success && <p className="profile-message">{success}</p>}
      </div>
    </div>
  );
}